<template>
  <Modal>
    <Modal.Body class="mt-2 tablet-h:mt-4">
      <FromInviteBody :email="email" />
    </Modal.Body>
  </Modal>
</template>

<script setup lang="ts">
import { Modal } from '@dacr/library'

import FromInviteBody from './FromInviteBody.vue'

defineProps<{
  email: string
}>()
</script>
